import { singleRequestServiceFactory } from 'rest/request/singleRequestServiceFactory';
import { incidentDetailsEndpoint } from 'endpoints';

export const incidentDetailsRest = singleRequestServiceFactory(incidentDetailsEndpoint);
